import script from "./CounterPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CounterPage.vue?vue&type=script&setup=true&lang=js"

import "./CounterPage.vue?vue&type=style&index=0&id=255475b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-255475b4"]])

export default __exports__